export const NOTES_GET_NOTES_BEGIN = 'NOTES_GET_NOTES_BEGIN';
export const NOTES_GET_NOTES_SUCCESS = 'NOTES_GET_NOTES_SUCCESS';
export const NOTES_GET_NOTES_FAILURE = 'NOTES_GET_NOTES_FAILURE';
export const NOTES_GET_NOTES_DISMISS_ERROR = 'NOTES_GET_NOTES_DISMISS_ERROR';
export const NOTES_CREATE_NOTE_BEGIN = 'NOTES_CREATE_NOTE_BEGIN';
export const NOTES_CREATE_NOTE_SUCCESS = 'NOTES_CREATE_NOTE_SUCCESS';
export const NOTES_CREATE_NOTE_FAILURE = 'NOTES_CREATE_NOTE_FAILURE';
export const NOTES_CREATE_NOTE_DISMISS_ERROR = 'NOTES_CREATE_NOTE_DISMISS_ERROR';
export const NOTES_UPDATE_NOTE_BEGIN = 'NOTES_UPDATE_NOTE_BEGIN';
export const NOTES_UPDATE_NOTE_SUCCESS = 'NOTES_UPDATE_NOTE_SUCCESS';
export const NOTES_UPDATE_NOTE_FAILURE = 'NOTES_UPDATE_NOTE_FAILURE';
export const NOTES_UPDATE_NOTE_DISMISS_ERROR = 'NOTES_UPDATE_NOTE_DISMISS_ERROR';
export const NOTES_GET_COMMENTS_BEGIN = 'NOTES_GET_COMMENTS_BEGIN';
export const NOTES_GET_COMMENTS_SUCCESS = 'NOTES_GET_COMMENTS_SUCCESS';
export const NOTES_GET_COMMENTS_FAILURE = 'NOTES_GET_COMMENTS_FAILURE';
export const NOTES_GET_COMMENTS_DISMISS_ERROR = 'NOTES_GET_COMMENTS_DISMISS_ERROR';
export const NOTES_CREATE_COMMENT_BEGIN = 'NOTES_CREATE_COMMENT_BEGIN';
export const NOTES_CREATE_COMMENT_SUCCESS = 'NOTES_CREATE_COMMENT_SUCCESS';
export const NOTES_CREATE_COMMENT_FAILURE = 'NOTES_CREATE_COMMENT_FAILURE';
export const NOTES_CREATE_COMMENT_DISMISS_ERROR = 'NOTES_CREATE_COMMENT_DISMISS_ERROR';
export const NOTES_UPDATE_COMMENT_BEGIN = 'NOTES_UPDATE_COMMENT_BEGIN';
export const NOTES_UPDATE_COMMENT_SUCCESS = 'NOTES_UPDATE_COMMENT_SUCCESS';
export const NOTES_UPDATE_COMMENT_FAILURE = 'NOTES_UPDATE_COMMENT_FAILURE';
export const NOTES_UPDATE_COMMENT_DISMISS_ERROR = 'NOTES_UPDATE_COMMENT_DISMISS_ERROR';
export const NOTES_GET_SEARCH_BEGIN = 'NOTES_GET_SEARCH_BEGIN';
export const NOTES_GET_SEARCH_SUCCESS = 'NOTES_GET_SEARCH_SUCCESS';
export const NOTES_GET_SEARCH_FAILURE = 'NOTES_GET_SEARCH_FAILURE';
export const NOTES_GET_SEARCH_DISMISS_ERROR = 'NOTES_GET_SEARCH_DISMISS_ERROR';
export const NOTES_DELETE_NOTE_BEGIN = 'NOTES_DELETE_NOTE_BEGIN';
export const NOTES_DELETE_NOTE_SUCCESS = 'NOTES_DELETE_NOTE_SUCCESS';
export const NOTES_DELETE_NOTE_FAILURE = 'NOTES_DELETE_NOTE_FAILURE';
export const NOTES_DELETE_NOTE_DISMISS_ERROR = 'NOTES_DELETE_NOTE_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/notes/redux/constants.js